module.exports = __webpack_public_path__ + "img/bg_function04_1_t.c2736678.gif";